import React from "react";

const SectionBody: React.FunctionComponent = ({ children, ...props }) => {
  return (
    <div
      css={{
        padding: 16,
        display: "grid",
        gridRowGap: 12,
      }}
      {...props}
    >
      {children}
    </div>
  );
};

export default SectionBody;
